import { entity } from '@talisdev/jsonapi-transformers';

import { HierarchyNode } from './hierarchy-node';

@entity({ type: 'pathways' })
export class Pathway extends HierarchyNode {}
